﻿/* 
Object:         Capcode
Description:    Logic and events for the module Capcode
Used in:        Capcode
*/

/*---[ ESLint ]---*/
/*
    global capcode
           
*/

window.capcode = function () {

    var _userId = 0;

    return {

        /**
         * initialize with the userid
         * @param {number} userId
         */
        initialize: function (userId) {

            // Create new record ...
            $(".k-grid-add").click(function (e) {
                // Prevent default behaviour
                e.preventDefault();
                capcode.showForm(true);
            });

            capcode.showForm(false);
            _userId = userId;
        },

        /**
         * get userId set by the function initialize.
         */
        userId_get: function () {
            return _userId;
        },

        /**
         * Show or hide the capcode input.
         * @param {boolean} show
         */
        showForm: function (show) {

            if (show) {
                $("#formCapCode").show();
            } else {
                $("#formCapCode").hide();
            }

            main.makeResultMessage();
        },

        /**
         * Form submission event
         * @param {Object} e
         */
        onFormSubmit: function (e) {

            // Post Data
            $.ajax({
                type: "POST",
                url: appsettings.getUrl(e.model.FormAction),
                data: {
                    capcode: e.model.CapCode,
                    userId: e.model.UserID
                },
                dataType: 'json',
                success: function (responseData) {
                    capcode.refreshGrid();
                    form.showServerResponse(responseData);
                }
            });

            // Prevent default behaviour
            e.preventDefault();
        },

        /**
         * Form clear, clear all form entries.
         * @param {Object} e
         */
        onFormClear: function (e) {
            capcode.showForm(false);
            main.makeResultMessage();
        },

        /**
         * Sets enabled to true or false. Called when user clicks checkbox.
         * @param {Object} e
         * @param {number} capcodeId
         * @param {number} userId
         */
        onEnableClicked: function (e, capcodeId, userId) {

            // Post Data
            $.ajax({
                type: "POST",
                url: appsettings.getUrl("User/SetEnabled"),
                data: {
                    enabled: e.checked,
                    capcode: capcodeId,
                    userId: userId
                },
                dataType: 'json',
                success: function (responseData) {
                    main.makeResultMessage(responseData);
                }
            });
        },

        
        /**
         * Template for checkbox Enabled in grid
         * @param {Object} data
         * @param {number} userId
         */
        template: function (data, userId) {
            return "<input name='cb' type='checkbox' " + (data.Enable ? "checked='checked'" : "") + " onclick='capcode.onEnableClicked(this, " + data.Capcode + ", " + userId + " );' />";
        },

        /**
         * On deletion clicked
         * @param {Object} e
         */
        onDeleteClicked: function (e) {
            var event = e;
            var data = this;

            function callbackYes(event, data) {
                // Prevent default behaviour 
                event.preventDefault();

                var dataItem = data.dataItem($(event.currentTarget).closest("tr"));
                capcode.removeItemFromUser(dataItem.Capcode);
            }

            function callingCallback() {
                callbackYes(event, data);
            }

            dialog.createDialog(callingCallback, function () { });
        },

        /**
         * Remove a item from the selected user. The selected user is set on initial load of page.
         * @param {number} capcodeId
         */
        removeItemFromUser: function (capcodeId) {

            $.ajax({
                type: "POST",                
                url: appsettings.getUrl("User/RemoveCapCode"),
                data: {
                    capcode: capcodeId,
                    userId: capcode.userId_get
                },
                dataType: 'json',
                success: function (responseData) {

                    capcode.refreshGrid();

                    if (responseData != undefined && responseData != null && !responseData.Succesfully) {                        
                        main.makeResultMessage(responseData);
                    }                    
                }
            });

        },

        /**
         * Refreshes the grid with capcodes for a user
         */
        refreshGrid: function () {

            var grid = $("#CapCodesGrid").data("kendoGrid");

            if (grid != undefined) {
                grid.dataSource.read(_userId);
            }
        }

    }

}();